var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.75C7.82107 9.75 9.5 8.07107 9.5 6C9.5 3.92893 7.82107 2.25 5.75 2.25C3.67893 2.25 2 3.92893 2 6C2 8.07107 3.67893 9.75 5.75 9.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 11.25C4.71165 11.25 3.69662 10.9421 2.83326 10.3652C1.9699 9.78834 1.29699 8.9684 0.899635 8.00909C0.502275 7.04978 0.398307 5.99418 0.60088 4.97578C0.803452 3.95738 1.30347 3.02192 2.03769 2.28769C2.77192 1.55347 3.70738 1.05345 4.72578 0.85088C5.74418 0.648307 6.79978 0.752275 7.75909 1.14963C8.7184 1.54699 9.53834 2.2199 10.1152 3.08326C10.6921 3.94662 11 4.96165 11 6C10.9984 7.39191 10.4448 8.72635 9.46058 9.71058C8.47635 10.6948 7.14191 11.2484 5.75 11.25ZM5.75 1.5C4.85999 1.5 3.98996 1.76392 3.24994 2.25839C2.50992 2.75286 1.93314 3.45566 1.59254 4.27793C1.25195 5.10019 1.16284 6.00499 1.33647 6.87791C1.5101 7.75082 1.93869 8.55265 2.56802 9.18198C3.19736 9.81132 3.99918 10.2399 4.8721 10.4135C5.74501 10.5872 6.64981 10.4981 7.47208 10.1575C8.29434 9.81687 8.99715 9.24009 9.49162 8.50007C9.98608 7.76005 10.25 6.89002 10.25 6C10.2486 4.80695 9.7741 3.66314 8.93048 2.81952C8.08686 1.9759 6.94306 1.50136 5.75 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipCircleFilled);
export default __webpack_public_path__ + "static/media/ic-chip-circle-filled.6f10ec3daff7617ea547d8bdb7399c2b.svg";
export { ForwardRef as ReactComponent };